/** @format */

const keyplayer = {
    testIcon: '/assets/images/svg/keyplayer/test-icon.svg',
    testTakenIcon: '/assets/images/svg/keyplayer/test-taken-icon.svg',
}

export default keyplayer

